import inventories from "../services/dstore.inventories";

import notification from "../services/notification";
// import _ from "lodash";
// import { stat } from "fs";

export default {
    namespaced: true,

    state: {
        loading: false,
        errors: null,
        products: [],
        productOptions: [],
        categories: [],
        advance_search: [],
        param: {
            page: 1,
            payload: {
                search: {
                    // paired_key: "all",
                    keyword: ""
                    // column: "all"
                }
            }
        },

        payment_type: null,
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        },
        modal: {
            new_product: {
                status: false
            },
            edit_product: {
                status: false
            },
            croppa: {
                status: false,
                base64: null,
                origin: null,
                additionalImage: null
            },
            delete_product: {
                status: false,
                name: "",
                uuid: null
            },
            check_tagged_product: {
                status: false,
                name: "",
                uuid: null
            }
        },
        product_active_img: null,
        sale: {
            dates: {
                on_sale_from: null,
                on_sale_to: null
            },
            all: false,
            all_discount_value: 1,
            all_discount_type: "%"
        },
        product_data: {},
        available_stocks: 0,
        maxPage: 0
    },

    mutations: {
        loading(state, status) {
            state.loading = status;
        },

        errors(state, errors) {
            if (errors !== null) {
                state.errors = errors.errors;
            } else {
                state.errors = errors;
            }
        },

        setAdvanceSearchOptions(state, values) {
            state.advance_search = values;
        },

        setParam(state, param) {
            state.param = param;
        },

        setProducts(state, products) {
            state.products = products;
        },

        clearProductOptions(state) {
            state.productOptions = [];
        },
        setProductOptions(state, productOptions) {
            const key = "uuid";
            state.productOptions = [
                ...new Map(
                    [...state.productOptions, ...productOptions].map(item => [
                        item[key],
                        item
                    ])
                ).values()
            ];
        },
        setMaxPage(state, maxPage) {
            state.maxPage = maxPage;
        },
        setCategories(state, categories) {
            state.categories = categories;
        },

        setInitialPageCount(state, list) {
            state.pagination.initialPageCount = list.length;
        },

        setCurrentPage(state, page) {
            state.pagination.currentPage = page;
        },

        setPagination(state, pagination) {
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage =
                state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount *
                    state.pagination.prevPage +
                    1
                    : 0;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem +
                    state.pagination.totalPerPage -
                    1
                    : 0;
        },

        setModal(state, param) {
            state.modal[param.type].status = param.status;

            if (param.type === "croppa") {
                state.modal[param.type].base64 = param.base64;
                state.modal[param.type].origin = param.origin;
                state.modal[param.type].additionalImage = param.additionalImage;
                if (param.status == false) {
                    state.modal[param.origin].status = true;
                }
            }

            if (param.type === "delete_product") {
                state.modal[param.type].uuid = param.uuid;
                state.modal[param.type].name = param.name;
            }

            if (param.type === "check_tagged_product") {
                state.modal[param.type].uuid = param.uuid;
                state.modal[param.type].name = param.name;
            }
        },

        setActiveImage(state, index) {
            state.product_active_img = index;
        },

        setProductData(state, data) {
            state.product_data = data;
        },
        setAvailableProductKeyStocks(state, data) {
            state.available_stocks = data;
        },
        setPaymentType(state, type) {
            state.payment_type = type;
        },

        setTaggedProducts(state, taggedProducts) {
            state.taggedProducts = taggedProducts;
        }
    },

    actions: {
        async getCategories({ commit, state }) {
            commit("loading", true);
            state.categories = [];
            try {
                let response = await inventories.getCategories();
                commit("setCategories", response.data.list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        async getAdvanceSearch({ commit }) {
            commit("loading", true);
            try {
                let { data } = await inventories.getAdvanceSearch();
                commit("setAdvanceSearchOptions", data.options);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        async getProducts({ commit, state }, param) {
            commit("loading", true);
            state.products = [];
            try {
                let response = await inventories.getProducts(param);

                if (param.page === 1) {
                    await commit("setInitialPageCount", response.data.list);
                }

                // response.data.list.forEach(function(cell) {
                //     if (cell.on_sale === 0) {
                //         cell["_cellVariants"] = {
                //             sale_price: "secondary",
                //             sale_schedule: "secondary"
                //         };
                //     } else {
                //         var onSaleToDate = new Date(cell.on_sale_to);
                //         var now = new Date();
                //         if (onSaleToDate < now) {
                //             cell["_cellVariants"] = { sale_price: "secondary" };
                //         }
                //     }
                // });
                commit("setProducts", response.data.list);
                commit("setPagination", response.data);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        async getProductOptions({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.getProducts(param);
                if (param.payload.search.keyword != "") {
                    commit("clearProductOptions");
                    commit("setProductOptions", response.data.list);
                } else {
                    // commit("clearProductOptions");
                    commit("setProductOptions", response.data.list);
                }
                commit("setMaxPage", response.data.max_page);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        async saveSimpleProduct({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.saveSimpleProduct(param);
                commit("loading", false);
                commit("errors", null);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, cannot create new product.");
            }
        },

        async updateProductVisibility({ }, data) {
            try {
                let response = await inventories.updateProductVisibility(data);
                notification.success(response.message);
            } catch (errors) {
                notification.warning("Oops, cannot update product visibility");
            }
        },

        async getProduct({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.getProduct(param);
                commit("loading", false);
                commit("setProductData", response.data);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        async getAvailableProductKeyStocks({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.getAvailableProductKeyStocks(
                    param
                );
                commit("loading", false);
                commit(
                    "setAvailableProductKeyStocks",
                    response.data.available_stocks
                );
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        async updateSimpleProduct({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.updateSimpleProduct(param);
                commit("loading", false);
                commit("errors", null);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, cannot update product.");
            }
        },

        async deleteProduct({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.deleteProduct(param.uuid);
                commit("loading", false);
                commit("errors", null);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors.errors);
                commit("loading", false);
                // notification.warning(errors.errors.message);
                commit("setModal", {
                    type: "check_tagged_product",
                    uuid: param.uuid,
                    name: param.name,
                    status: true
                });
            }
        },

        async saveVariableProduct({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.saveVariableProduct(param);
                commit("loading", false);
                commit("errors", null);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, cannot create new product");
            }
        },

        async updateVariableProduct({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.updateVariableProduct(param);
                commit("loading", false);
                commit("errors", null);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, cannot update product.");
            }
        }
    }
};
